const managementSections =
  [
    {
      page: 'powerBIPage',
      id: 'btn_powerbi',
      code: 'powerbi',
      icon: 'iDocIcon-admin-tools',
      title: 'REPORTS.POWERBI'
    },
    {
      page: 'fleetReportPage',
      id: 'btn_masters',
      code: 'fleetReport',
      icon: 'iDocIcon-admin-tools',
      title: 'SEARCH.CATEGORIES.FLEETREPORT.TITLE'
    },
    {
      page: 'commercialReportPage',
      id: 'btn_masters',
      code: 'reportCommercial',
      icon: 'iDocIcon-admin-tools',
      title: 'SEARCH.CATEGORIES.REPORT.COMMERCIAL_REPORT'
    },
    {
      page: 'usageReportPage',
      id: 'btn_masters',
      code: 'usage_report',
      icon: 'iDocIcon-admin-tools',
      title: 'REPORTS.USAGE.USAGE_TITLE'
    }
  ]

export default managementSections
